import React from "react";
// ANT DESIGN COMPONENTS
import { Button, Tooltip } from "antd";
// FONT AWESOME LIBRARY AND ICONS
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleInfo } from "@fortawesome/free-solid-svg-icons";

/**
 * Header + list shell for a group of action cards.
 *
 * Replaces the stack of `<Divider orientation="left">` bars — one per button
 * type — that used to slice the panel into seven decorated sections. Actions now
 * render as one continuous list with the type carried by each card's tag, so the
 * separators no longer have to encode information.
 */
export default function ActionsPanel({
  title,
  subtitle = undefined,
  helpText = undefined,
  helpLabel = undefined,
  theme,
  children,
}: {
  title: string;
  subtitle?: string;
  /** Optional tooltip body for the header's info affordance. */
  helpText?: string;
  helpLabel?: string;
  theme: string;
  children: React.ReactNode;
}) {
  return (
    <section className={`actionsPanel actionsPanel__${theme}`}>
      <header className="actionsPanel__header">
        <div className="actionsPanel__headerText">
          <h4 className="actionsPanel__title">{title}</h4>
          {subtitle && <p className="actionsPanel__subtitle">{subtitle}</p>}
        </div>
        {helpText && (
          <Tooltip title={helpText} placement="topRight">
            <Button
              type="text"
              shape="circle"
              className="actionCard__infoButton"
              aria-label={helpLabel ?? title}
            >
              <FontAwesomeIcon icon={faCircleInfo} fontSize={16} className="generalStyles__info" />
            </Button>
          </Tooltip>
        )}
      </header>
      <div className="actionsPanel__list">{children}</div>
    </section>
  );
}
